import React from "react";
import PropTypes from "prop-types";

const CustomInputComponent = ({ value, readOnly, style }) => {
  let displayValue = typeof value === "number" ? value.toFixed(4) : value;

  return (
    <input
      readOnly={readOnly}
      style={style}
      value={displayValue ?? ""}
      className={readOnly ? "lovable-readonly-input" : undefined}
    />
  );
};

CustomInputComponent.propTypes = {
  value: PropTypes.any,
  readOnly: PropTypes.bool,
  style: PropTypes.object,
};

CustomInputComponent.defaultProps = {
  readOnly: false,
};

export default CustomInputComponent;
